export function imageDraggable() {
  const Draggabilly = require('draggabilly');
  const draggableElems = document.querySelectorAll('.js-archive-image-container');
  const draggies = [];
  let zindex = 2;
  const closest = (el, targetClass) => {
    for (let item = el; item; item = item.parentElement) {
      if (item.classList.contains(targetClass)) {
        return item
      }
    }
  }
  for (let i = 0; i < draggableElems.length; i++) {
    const draggableElem = draggableElems[i];
    const draggableElemID = draggableElem.getAttribute('data-id');
    const draggie = new Draggabilly(draggableElem);
    draggie.on('dragStart', function(event, pointer, moveVector) {
      const titleElem = document.querySelector(`.post-${draggableElemID}`);
      titleElem.classList.add('is-shaking');
    });
    draggie.on('dragEnd', function(event,pointer) {
      const titleElem = document.querySelector(`.post-${draggableElemID}`);
      titleElem.classList.remove('is-shaking');
      draggableElem.style.zIndex = zindex;
      zindex++;
    });
    draggie.on('staticClick', function(event, pointer) {
      draggableElem.querySelector('.js-post-trigger').click();
    });
    draggies.push(draggie);

    if(!IS_TOUCH) {
      draggableElem.addEventListener('mouseenter', function(e) {
        const titleElem = document.querySelector(`.post-${draggableElemID}`);
        const parent = closest(titleElem, 'js-hover-parent');
        if(parent) {
          parent.classList.add('hover-parent');
        }
      });
      draggableElem.addEventListener('mouseleave', function(e) {
        const titleElem = document.querySelector(`.post-${draggableElemID}`);
        const parent = closest(titleElem, 'js-hover-parent');
        if(parent) {
          parent.classList.remove('hover-parent');
        }
      });
    }
  }
}